import { h } from 'preact';
import { forwardRef } from 'preact/compat';
import './style.scss';

const TextArea = forwardRef<HTMLTextAreaElement, h.JSX.HTMLAttributes<HTMLTextAreaElement>>(
  ({ className = '', ...rest }, ref) => {
    return (
      <div className={`text-area_ta`}>
        <textarea
          max={240}
          maxLength={240}
          ref={ref}
          style={{
            resize: 'none',
            padding: '10px',
          }}
          className={`${className}`}
          {...rest}
        />
      </div>
    );
  }
);

export default TextArea;
